import React from "react";
import { FormProvider } from "react-hook-form";
import { Edit } from "@refinedev/mui";

import { BannerForm } from "@modules/banners/components/BannerForm";
import { useBannerEditForm } from "./controller";

export const BannerEdit = React.memo(() => {
  const { methods, handleSubmit, mutateAsync, isPending, formLoading, id } = useBannerEditForm();

  return (
    <Edit
      recordItemId={id}
      saveButtonProps={{
        onClick: handleSubmit(mutateAsync as any),
        loading: isPending,
      }}
      isLoading={formLoading}
    >
      <FormProvider {...methods}>
        <BannerForm />
      </FormProvider>
    </Edit>
  );
});
